import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent } from 'src/components/mui-components';
import { designSevenPagePath } from 'src/designSevenPagePath';
import { useTranslation } from 'react-i18next';
import { PersonalPlanTable } from './components';

export const PersonalPlan = () => {
  const { t } = useTranslation('personalPlan');
  const navigate = useNavigate();
  const { state } = useLocation();

  const closeModal = () => {
    if (state?.background) {
      navigate(-1);
    } else {
      navigate(designSevenPagePath.home);
    }
  };

  return (
    <Dialog open maxWidth="lg" onClose={() => closeModal()}>
      <DialogTitle closeText={t('ModalCloseButton')} closeModal={closeModal}>
        {t('HeadingText')} (<abbr title={t('HoursLabel')}>{t('HoursAbbrLabel')}</abbr>)
      </DialogTitle>
      <DialogContent sx={{ minHeight: '80vh' }}>
        <PersonalPlanTable data-automation-id="PersonalPlanWidget" />
      </DialogContent>
    </Dialog>
  );
};
